import flatpickr from 'flatpickr';
import FlatpickrLangs from './FlatpickrLangs';
import type { Naja } from 'naja';
import IExtension from '../../IExtension';
import FlatpickrFormatter from "./FlatpickrFormatter";

export default class DatePicker implements IExtension {
    constructor (
        public selector = "input[type='date'], [data-provide='datepicker'], .datepicker"
    ) {
        this.selector = selector;
    }

    initialize (naja: Naja): void {
        this.init();

        naja.snippetHandler.addEventListener('afterUpdate', (e) => {
            this.init(e.detail.snippet);
        });
    }

    private init (root?: HTMLElement|Element): void {
        const $root = root ? $(root) : $('body');
        $.each($root.find(this.selector), (i, el) => {

            const options = {
                dateFormat: 'Y-m-d',
                altInputClass: $(el).attr('class'),
                altFormat: $(el).data('format') ? FlatpickrFormatter.transformFormat($(el).data('format')) : 'd.m.Y',
                altInput: true,
                locale: FlatpickrLangs.lang,
            };

            if ($(el).is('[data-date-in-future]')) {
                options['minDate'] = 'today';
            }

            if ($(el).is('[data-date-in-past]')) {
                options['maxDate'] = 'today';
            }

            if ($(el).data('min-date')) {
                options['minDate'] = $(el).data('min-date');
            }

            if ($(el).data('max-date')) {
                options['maxDate'] = $(el).data('max-date');
            }

            // @ts-ignore
            const fp = flatpickr(el, options);

            // show errors on altInput instead of original hidden input, see www/assets/extensions/NetteFormsExtension.ts:81
            $(el).data('error-target', fp.altInput);

            // this is needed to find label of original input to show errors there, see www/assets/extensions/NetteFormsExtension.ts:46
            $(fp.altInput).attr('id', $(el).attr('id')).data('original-input', el);
            $(el).attr('id', null);
        });
    }
}
